import Button from '@components/Button';
import useModal from '@hooks/ui/useModal';
import { CancelGiftOrderRequest } from '@models/gift';
import { useFlow } from '@router/stackflow';

import styles from './styles.module.scss';

function RefundButton({ giftItemType, giftBoxItemId }:CancelGiftOrderRequest) {
  const { push } = useFlow();
  const confirmCancel = () => {
    push('GiftCancelModal', { giftItemType, giftBoxItemId });
  };
  return (
      <Button fullWidth
              onClick={confirmCancel}>
          결제 취소
      </Button>
  );
}

export default RefundButton;
